import { MenuApp } from './MenuApp';
import { registerReactWebComponent, parseListAttribute } from '@/core/utils/webComponent';

const getCombinedValue = (element, params, attr, camelParam) =>
  element.getAttribute(attr) || params.get(camelParam) || params.get(attr);

const getListValue = (element, params, attr, camelParam) => {
  const value = element.getAttribute(attr) ?? params.get(camelParam) ?? params.get(attr);
  return parseListAttribute(value);
};

const getStringProp = (element, params, attr, camelParam) =>
  getCombinedValue(element, params, attr, camelParam) || undefined;

const processDisabledItems = (items) => {
  if (!items) return undefined;
  return items.map((item) => {
    if (typeof item === 'string' && item.includes(':')) {
      const [id, reason] = item.split(':');
      return { id, reason: reason === 'upgrade' || reason === 'permission' ? reason : undefined };
    }
    return item;
  });
};

const extractMenuProps = (element) => {
  const params = new URLSearchParams(globalThis.location?.search || '');

  return {
    itemIds: getListValue(element, params, 'items', 'items'),
    disabledItemIds: processDisabledItems(getListValue(element, params, 'disabled-items', 'disabled-items')),
    accountId: getStringProp(element, params, 'account-id', 'accountId'),
    accountName: getStringProp(element, params, 'account-name', 'accountName'),
    profileImage: getStringProp(element, params, 'profile-image', 'profileImage'),
    searchOptions: getListValue(element, params, 'search-options', 'searchOptions'),
    selectedSearch: getStringProp(element, params, 'selected-search', 'selectedSearch'),
    universeId: getStringProp(element, params, 'universe-id', 'universeId'),
  };
};

export const registerMenuComponent = () => {
  registerReactWebComponent('content-menu', MenuApp, extractMenuProps);
};
